import { faUserFriends } from '@fortawesome/free-solid-svg-icons'
import env from './env'
import { faClipboard, faEnvelope, faFaceDizzy } from '@fortawesome/free-regular-svg-icons'

export interface NavItem {
    path: string
    basename: string
    icon?: any
    name: string
    active?: string[]
    children?: {
        path: string
        basename: string
        name: string
        active?: RegExp[]
    }[]
}

interface NavCategory {
    title: string
    items: NavItem[]
}

interface NavCategory {
    title: string
    items: NavItem[]
}

const navs: NavCategory[] = [
    {
        title: '콘텐츠',
        items: [
            {
                path: 'broadcast',
                basename: 'broadcast',
                icon: ['far', 'calendar'],
                name: '라이브 관리',
                children: [
                    {
                        path: '/broadcast',
                        basename: 'broadcast',
                        name: '라이브 예약',
                        active: [
                            /^\/broadcast(\/\d+)?$/, // 라이브 상세페이지
                            /^\/broadcast\/reservation$/, // 라이브 예약 페이지
                            /^\/broadcast\/result/, // 라이브 예약 완료 페이지
                            /^\/broadcast\/detail/, // 라이브 세부정보 등록 페이지
                            /^\/broadcast\/edit/, // 라이브 정보 수정
                        ],
                    },
                    {
                        path: '/broadcast/shipping-info',
                        basename: 'shipping-info',
                        name: '라이브 기본 설정',
                        active: [/^\/broadcast\/\d+\/shipping-info$/],
                    },
                ],
            },
            {
                path: '/point',
                basename: 'point',
                icon: ['far', 'gem'],
                name: '포인트 관리',
            },
            {
                path: 'chat',
                active: ['/tag'],
                basename: 'chat',
                icon: ['far', 'comment-dots'],
                name: '문의톡 관리',
                children: [
                    {
                        path: '/chat',
                        basename: 'chat',
                        name: '문의톡 목록',
                        active: [/^\/chat(\/\d+)?$/],
                    },
                    {
                        path: '/tag',
                        basename: 'tag',
                        name: '태그 관리',
                    },
                ],
            },
            {
                path: env.LIVE_LIST_SRC,
                basename: 'order details',
                icon: faClipboard,
                name: '주문관리',
            },
            {
                path: '/manager',
                basename: 'manager',
                icon: ['far', 'bell'],
                name: '매니저 관리',
            },
            {
                path: '/block',
                basename: 'block',
                icon: faFaceDizzy,
                name: '차단 유저 관리',
            },
        ],
    },
    {
        title: '제휴',
        items: [
            {
                path: '/partnership',
                basename: 'partnership',
                icon: faUserFriends,
                name: '파트너 목록',
            },
        ],
    },
    {
        title: '사용자',
        items: [
            {
                path: '/profile',
                basename: 'profile',
                icon: 'cog',
                name: '내 설정',
            },
            {
                path: '/notice',
                basename: 'notice',
                icon: 'pen-to-square',
                name: '공지사항',
            },
            {
                path: 'https://tally.so/r/mOd06g',
                basename: 'feedback',
                icon: faEnvelope,
                name: '의견 보내기',
            },
            {
                path: '/logout',
                basename: 'logout',
                icon: 'arrow-right-from-bracket',
                name: '로그아웃',
            },
        ],
    },
]

export default navs
